

 const getVRUDefaultCustomLegendMapping = [
   {
   
   section_name: 'Systemic Scores (VRU Only)',
   collpsed: false,
    section_details: [
      { type: 'group',
        group_name: 'Types of Systemic Scores',
        visible: true,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
           {
        type: 'layer',
        layer_name: 'Systemic Score Intersections',
        layer_id: 'systemicIntersectionLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,  
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        //0-2, 2-4,4-6,6-8,8-10
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Segments',
        layer_id: 'systemicSegmentLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Ramps',
        layer_id: 'systemicRampLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
        ]}
     
],},
  {
    
   section_name: 'TSN Historical Crashes',
   collpsed: false,
    section_details: [
       { 
      type: 'group',
      group_name: 'Location Type  ',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: true,
      group_details: [
          {
        type: 'layer',
        layer_name: 'VRU Intersection Crashes',
        layer_id: 'historicalHCCLIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'VRU Segment Crashes',
        layer_id: 'historicalHighCollisonLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'VRU Ramp Crashes',
        layer_id: 'historicalHighCollisonRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '51+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */

      ]}
    ],},
    { section_name: 'Hard Braking Events',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Hard Braking Events (Google RMI)',
        layer_id: 'hardBrakingLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
       legend_label: ['0.000', '0.156+'],
          legend_value: ['rgba(120, 38, 56, .25)', 'rgba(120, 38, 56, .5)', 'rgba(120, 38, 56, .7)', 'rgba(120, 38, 56, .85)', 'rgba(120, 38, 56, 1)'],
  },
  ],},
  {
   section_name: 'Lane Closures',
   collpsed: false,
    section_details: [
      {
      type: 'group',
      group_name: 'Location Type',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
      {
        type: 'layer',
        layer_name: 'Lane Closure Segments',
        layer_id: 'laneClosureSafetySegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Lane Closure Points',
        layer_id: 'laneClosureSafetyPointLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      ]
      },
    ],},
  { section_name: 'Replica Daily Trips (2024)',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Pedestrian Volumes',
        layer_id: 'historicalPedestrianVolumeLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['1-25', '201+'],
          legend_value: ['rgba(15, 133, 84, .25)', 'rgba(15, 133, 84, .5)', 'rgba(15, 133, 84, .75)', 'rgba(15, 133, 84, 1)'],
  },
  {
          type: 'layer',
          layer_name: 'Bike Volumes',
          layer_id: 'historicalBikerVolumeLayer',
          visible: false,
          defaultopacity: 0.8,
          opacity: 0.8,
          isOpacityControlOpen: false,
          collpsed: false,
          isDiffColored: true,
          legend_type: 'scale',
          legend_label: ['1-25', '201+'],
          legend_value: ['rgba(29, 105, 150, .25)', 'rgba(29, 105, 150, .5)', 'rgba(29, 105, 150, .75)', 'rgba(29, 105, 150, 1)'],
    }
  ],},
   { section_name: 'Transit Routes & Stops',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Transit Routes',
      layer_id: 'transitRouteLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'solid_line',
      legend_label: ['Transit Route Line'],
      legend_value: ['rgba(213, 100, 249,1)'],
    },
  {
      type: 'layer',
      layer_name: 'Transit Stop by Priorization Score',
      layer_id: 'transitStopLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'scale',
      legend_label: ['1', '10'],
      legend_value: ['rgba(249, 144, 6, .25)', 'rgba(249, 144, 6, .5)', 'rgba(249, 144, 6, .6)', 'rgba(249, 144, 6, .75)', 'rgba(249, 144, 6, 1)'],
    },],},
  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Points of Interest',
      layer_id: 'pointOfInterestLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'icon',
      legend_label: ['Public School', 'Healthcare Facility'],
      legend_value: [require('../../assets/school.png'), require('../../assets/hospital.png')],
    },],},

  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Caltrans Equity Index',
      layer_id: 'calEquityIndexLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'polygon',
      legend_label: ['Priority Populations','Traffic Exposure','Access to Destinations','Demographic Overlay','Non-Screened Blocks'],
      legend_value: ['#810F7C','#8856A7','#8C96C6','#B3CDE3','#EDF8FB', ],
    },],},
   
  { section_name: '',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Caltrans District Boundaries',
        layer_id: 'DistrictBoundariesLayer',
        visible: true,
        defaultopacity: 0.15,
        opacity: 0.15,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'solid_line',
        legend_label: ['Caltrans Districts'],
        legend_value: ['#000000ff'],
  },],}
  ];

 const getDefaultCustomLegendMapping = [
   {
   
   section_name: 'Systemic Scores (Motor Vehicle Only)',
   collpsed: false,
    section_details: [
      { type: 'group',
        group_name: 'Types of Systemic Scores',
        visible: true,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
           {
        type: 'layer',
        layer_name: 'Systemic Score Intersections',
        layer_id: 'systemicIntersectionLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,  
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        //0-2, 2-4,4-6,6-8,8-10
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Segments',
        layer_id: 'systemicSegmentLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Ramps',
        layer_id: 'systemicRampLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
        ]}
     
],},
  {
    
   section_name: 'TSN Historical Crashes',
   collpsed: false,
    section_details: [
       { 
      type: 'group',
      group_name: 'Location Type  ',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: true,
      group_details: [
          {
        type: 'layer',
        layer_name: 'VRU Intersection Crashes',
        layer_id: 'historicalHCCLIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'VRU Segment Crashes',
        layer_id: 'historicalHighCollisonLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'VRU Ramp Crashes',
        layer_id: 'historicalHighCollisonRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '51+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */

      ]}
    ],},
    { section_name: 'Hard Braking Events',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Hard Braking Events (Google RMI)',
        layer_id: 'hardBrakingLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['0.000', '0.156+'],
          legend_value: ['rgba(120, 38, 56, .25)', 'rgba(120, 38, 56, .5)', 'rgba(120, 38, 56, .7)', 'rgba(120, 38, 56, .85)', 'rgba(120, 38, 56, 1)'],
  },
  ],},
  {
   section_name: 'Lane Closures',
   collpsed: false,
    section_details: [
      {
      type: 'group',
      group_name: 'Location Type',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: true,
      group_details: [
      {
        type: 'layer',
        layer_name: 'Lane Closure Segments',
        layer_id: 'laneClosureSafetySegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Lane Closure Points',
        layer_id: 'laneClosureSafetyPointLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      ]
      },
    ],},
  { section_name: 'Replica Daily Trips (2024)',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Pedestrian Volumes',
        layer_id: 'historicalPedestrianVolumeLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['1-25', '201+'],
          legend_value: ['rgba(15, 133, 84, .25)', 'rgba(15, 133, 84, .5)', 'rgba(15, 133, 84, .75)', 'rgba(15, 133, 84, 1)'],
  },
  {
          type: 'layer',
          layer_name: 'Bike Volumes',
          layer_id: 'historicalBikerVolumeLayer',
          visible: false,
          defaultopacity: 0.8,
          opacity: 0.8,
          isOpacityControlOpen: false,
          collpsed: false,
          isDiffColored: true,
          legend_type: 'scale',
          legend_label: ['1-25', '201+'],
          legend_value: ['rgba(29, 105, 150, .25)', 'rgba(29, 105, 150, .5)', 'rgba(29, 105, 150, .75)', 'rgba(29, 105, 150, 1)'],
    }
  ],},
   { section_name: 'Transit Routes & Stops',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Transit Routes',
      layer_id: 'transitRouteLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'solid_line',
      legend_label: ['Transit Route Line'],
      legend_value: ['rgba(213, 100, 249,1)'],
    },
  {
      type: 'layer',
      layer_name: 'Transit Stop by Priorization Score',
      layer_id: 'transitStopLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'scale',
      legend_label: ['1', '10'],
      legend_value: ['rgba(249, 144, 6, .25)', 'rgba(249, 144, 6, .5)', 'rgba(249, 144, 6, .6)', 'rgba(249, 144, 6, .75)', 'rgba(249, 144, 6, 1)'],
    },],},
  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Points of Interest',
      layer_id: 'pointOfInterestLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'icon',
      legend_label: ['Public School', 'Healthcare Facility'],
      legend_value: [require('../../assets/school.png'), require('../../assets/hospital.png')],
    },],},

  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Caltrans Equity Index',
      layer_id: 'calEquityIndexLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'polygon',
      legend_label: ['Priority Populations','Traffic Exposure','Access to Destinations','Demographic Overlay','Non-Screened Blocks'],
      legend_value: ['#810F7C','#8856A7','#8C96C6','#B3CDE3','#EDF8FB', ],
    },],},
   
  { section_name: '',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Caltrans District Boundaries',
        layer_id: 'DistrictBoundariesLayer',
        visible: true,
        defaultopacity: 0.15,
        opacity: 0.15,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'solid_line',
        legend_label: ['Caltrans Districts'],
        legend_value: ['#000000ff'],
  },],}
  ];
 const getVRUCustomLegendMapping = [
  {
   
   section_name: 'Systemic Scores (VRU Only)',
   collpsed: false,
    section_details: [
      { type: 'group',
        group_name: 'Types of Systemic Scores',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: false,
        group_details: [
           {
        type: 'layer',
        layer_name: 'Systemic Score Intersections',
        layer_id: 'systemicIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,  
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        //0-2, 2-4,4-6,6-8,8-10
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Segments',
        layer_id: 'systemicSegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Ramps',
        layer_id: 'systemicRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
        ]}
     
],},
  {
    
   section_name: 'TSN Historical Crashes (VRU Only)',
   collpsed: false,
    section_details: [
       { 
      type: 'group',
      group_name: 'Location Type ',
      visible: true,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
 //  {
      //   type: 'layer',
      //   layer_name: 'VRU HCCL Segment',
      //   layer_id: 'historicalHCCLLayer',
      //   visible: true,
      //   defaultopacity: 0.95,
      //   opacity: 0.95,
      //   isOpacityControlOpen: false,
      //   isDiffColored: false,
      //   legend_type: 'solid_line',
      //   legend_value: '#D500F9',
      // },
      {
        type: 'layer',
        layer_name: 'Intersection Crashes (VRU Only)',
        layer_id: 'historicalHCCLIntersectionLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Segment Crashes (VRU Only)',
        layer_id: 'historicalHighCollisonLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'Ramp Crashes (VRU Only)',
        layer_id: 'historicalHighCollisonRampLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '10+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '51+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */
      ]}
     
],},
{
    
   section_name: 'TSN Historical Crashes',
   collpsed: true,
    section_details: [
      { 
      type: 'group',
      group_name: 'Location Type',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
 {
        type: 'layer',
        layer_name: 'Intersection Crashes',
        layer_id: 'tsnHistoricalIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Segment Crashes',
        layer_id: 'tsnHistoricalSegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'Ramp Crashes',
        layer_id: 'tsnHistoricalRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '200+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */
      ]
    },
],},
 { section_name: 'Hard Braking Events',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Hard Braking Events (Google RMI)',
        layer_id: 'hardBrakingLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['0.000', '0.156+'],
          legend_value: ['rgba(120, 38, 56, .25)', 'rgba(120, 38, 56, .5)', 'rgba(120, 38, 56, .7)', 'rgba(120, 38, 56, .85)', 'rgba(120, 38, 56, 1)'],
  },
  ],},
  {
   section_name: 'Lane Closures',
   collpsed: false,
    section_details: [
      {
      type: 'group',
      group_name: 'Location Type',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
      {
        type: 'layer',
        layer_name: 'Lane Closure Segments',
        layer_id: 'laneClosureSafetySegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Lane Closure Points',
        layer_id: 'laneClosureSafetyPointLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      ]
      },
    ],},
  { section_name: 'Replica Daily Trips (2024)',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Pedestrian Volumes',
        layer_id: 'historicalPedestrianVolumeLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['1-25', '201+'],
          legend_value: ['rgba(15, 133, 84, .25)', 'rgba(15, 133, 84, .5)', 'rgba(15, 133, 84, .75)', 'rgba(15, 133, 84, 1)'],
  },
  {
          type: 'layer',
          layer_name: 'Bike Volumes',
          layer_id: 'historicalBikerVolumeLayer',
          visible: false,
          defaultopacity: 0.8,
          opacity: 0.8,
          isOpacityControlOpen: false,
          collpsed: false,
          isDiffColored: true,
          legend_type: 'scale',
          legend_label: ['1-25', '201+'],
          legend_value: ['rgba(29, 105, 150, .25)', 'rgba(29, 105, 150, .5)', 'rgba(29, 105, 150, .75)', 'rgba(29, 105, 150, 1)'],
    }
  ],},
   { section_name: 'Transit Routes & Stops',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Transit Routes',
      layer_id: 'transitRouteLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'solid_line',
      legend_label: ['Transit Route Line'],
      legend_value: ['rgba(213, 100, 249,1)'],
    },
  {
      type: 'layer',
      layer_name: 'Transit Stop Priorization Score',
      layer_id: 'transitStopLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'scale',
      legend_label: ['1', '10'],
      legend_value: ['rgba(249, 144, 6, .25)', 'rgba(249, 144, 6, .5)', 'rgba(249, 144, 6, .6)', 'rgba(249, 144, 6, .75)', 'rgba(249, 144, 6, 1)'],
    },],},
  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Points of Interest',
      layer_id: 'pointOfInterestLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'icon',
      legend_label: ['Public School', 'Healthcare Facility'],
      legend_value: [require('../../assets/school.png'), require('../../assets/hospital.png')],
    },],},

  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Caltrans Equity Index',
      layer_id: 'calEquityIndexLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'polygon',
      legend_label: ['Priority Populations','Traffic Exposure','Access to Destinations','Demographic Overlay','Non-Screened Blocks'],
      legend_value: ['#810F7C','#8856A7','#8C96C6','#B3CDE3','#EDF8FB', ],
    },],},
   
  { section_name: '',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Caltrans District Boundaries',
        layer_id: 'DistrictBoundariesLayer',
        visible: true,
        defaultopacity: 0.15,
        opacity: 0.15,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'solid_line',
        legend_label: ['Caltrans Districts'],
        legend_value: ['#000000ff'],
  },],}
  ];

  const getCustomLegendMapping = [
  {
   
   section_name: 'Systemic Scores (Motor Vehicle Only)',
   collpsed: false,
    section_details: [
    { 
      type: 'group',
      group_name: 'Types of Systemic Scores',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
          {
        type: 'layer',
        layer_name: 'Systemic Score Intersections',
        layer_id: 'systemicIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,  
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        //0-2, 2-4,4-6,6-8,8-10
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Segments',
        layer_id: 'systemicSegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Systemic Score Ramps',
        layer_id: 'systemicRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['0', '9'],
        legend_value: ['rgba(145, 53, 125, .2)','rgba(145, 53, 125, .4)','rgba(145, 53, 125, .6)','rgba(145, 53, 125, .8)','rgba(145, 53, 125, 1)'],
      },
        ]}
     
],},
  {
    
   section_name: 'TSN Historical Crashes (Motor Vehicle Only)',
   collpsed: false,
    section_details: [
      { 
      type: 'group',
      group_name: 'Location Type',
      visible: true,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
 {
        type: 'layer',
        layer_name: 'Intersection Crashes (Vehicle Only)',
        layer_id: 'historicalHCCLIntersectionLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Segment Crashes (Vehicle Only)',
        layer_id: 'historicalHighCollisonLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'Ramp Crashes (Vehicle Only)',
        layer_id: 'historicalHighCollisonRampLayer',
        visible: true,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '200+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */
      ]
    },
],},
{
    
   section_name: 'TSN Historical Crashes',
   collpsed: true,
    section_details: [
      { 
      type: 'group',
      //Trailing Space Differentiates from the other 'Location Type' group
      group_name: 'Location Type ',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: true,
      group_details: [
 {
        type: 'layer',
        layer_name: 'Intersection Crashes',
        layer_id: 'tsnHistoricalIntersectionLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Segment Crashes',
        layer_id: 'tsnHistoricalSegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
  {
        type: 'layer',
        layer_name: 'Ramp Crashes',
        layer_id: 'tsnHistoricalRampLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1', '200+'],
        legend_value: ['rgba(235, 74, 64, .25)', 'rgba(235, 74, 64, .5)', 'rgba(235, 74, 64, .75)', 'rgba(235, 74, 64, 1)'],
  },
 
      /* {
        type: 'layer',
        layer_name: 'Near Miss Events',
        layer_id: 'historicalMooveAiLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: true,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'scale',
        legend_label: ['1-10', '200+'],
        legend_value: ['#FCE7D9', '#F9CFB2', '#E9AB78', '#C96D11'],
              }, */
      ]
    },
],},
{ section_name: 'Hard Braking Events',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Hard Braking Events (Google RMI)',
        layer_id: 'hardBrakingLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['0.000', '0.156+'],
          legend_value: ['rgba(120, 38, 56, .25)', 'rgba(120, 38, 56, .5)', 'rgba(120, 38, 56, .7)', 'rgba(120, 38, 56, .85)', 'rgba(120, 38, 56, 1)'],
  },
  ],},
  {
   section_name: 'Lane Closures',
   collpsed: false,
    section_details: [
      {
      type: 'group',
      group_name: 'Location Point and Segments',
      visible: false,
      defaultopacity: 0.8,
      opacity: 0.8,
      isOpacityControlOpen: false,
      collpsed: false,
      group_details: [
      {
        type: 'layer',
        layer_name: 'Lane Closure Segments',
        layer_id: 'laneClosureSafetySegmentLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      {
        type: 'layer',
        layer_name: 'Lane Closure Points',
        layer_id: 'laneClosureSafetyPointLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'solid_line',
        legend_label: ['Electrical Work', 'Highway Construction', 'Pavement Work', 'Guardrail Work', 'Utility Work', 'Other Work'],
        legend_value: ['rgba(103, 188, 199, 1)', 'rgba(232, 195, 102, 1)', 'rgba(234, 141, 99, 1)', 'rgba(199, 160, 224, 1)', 'rgba(124, 188, 87, 1)', 'rgba(163, 163, 163, 1)'],
      },
      ]
      },
    ],},
  { section_name: 'Replica Daily Trips (2024)',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Pedestrian Volumes',
        layer_id: 'historicalPedestrianVolumeLayer',
        visible: false,
        defaultopacity: 0.8,
        opacity: 0.8,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['1-25', '201+'],
          legend_value: ['rgba(15, 133, 84, .25)', 'rgba(15, 133, 84, .5)', 'rgba(15, 133, 84, .75)', 'rgba(15, 133, 84, 1)'],
  },
  {
          type: 'layer',
          layer_name: 'Bike Volumes',
          layer_id: 'historicalBikerVolumeLayer',
          visible: false,
          defaultopacity: 0.8,
          opacity: 0.8,
          isOpacityControlOpen: false,
          collpsed: false,
          isDiffColored: true,
          legend_type: 'scale',
          legend_label: ['1-25', '201+'],
          legend_value: ['rgba(29, 105, 150, .25)', 'rgba(29, 105, 150, .5)', 'rgba(29, 105, 150, .75)', 'rgba(29, 105, 150, 1)'],
    }
  ],},
   { section_name: 'Transit Routes & Stops',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Transit Routes',
      layer_id: 'transitRouteLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'solid_line',
      legend_label: ['Transit Route Line'],
      legend_value: ['rgba(213, 100, 249,1)'],
    },
  {
      type: 'layer',
      layer_name: 'Transit Stop Priorization Score',
      layer_id: 'transitStopLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'scale',
      legend_label: ['1', '10'],
      legend_value: ['rgba(249, 144, 6, .25)', 'rgba(249, 144, 6, .5)', 'rgba(249, 144, 6, .6)', 'rgba(249, 144, 6, .75)', 'rgba(249, 144, 6, 1)'],
    },],},
  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Points of Interest',
      layer_id: 'pointOfInterestLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'icon',
      legend_label: ['Public School', 'Healthcare Facility'],
      legend_value: [require('../../assets/school.png'), require('../../assets/hospital.png')],
    },],},

  { section_name: '',
    section_details: [
    {
      type: 'layer',
      layer_name: 'Caltrans Equity Index',
      layer_id: 'calEquityIndexLayer',
      visible: false,
      defaultopacity: 0.3,
      opacity: 0.3,
      isOpacityControlOpen: false,
      collpsed: false,
      isDiffColored: true,
      legend_type: 'polygon',
      legend_label: ['Priority Populations','Traffic Exposure','Access to Destinations','Demographic Overlay','Non-Screened Blocks'],
      legend_value: ['#810F7C','#8856A7','#8C96C6','#B3CDE3','#EDF8FB', ],
    },],},
   
  { section_name: '',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Caltrans District Boundaries',
        layer_id: 'DistrictBoundariesLayer',
        visible: true,
        defaultopacity: 0.15,
        opacity: 0.15,
        isOpacityControlOpen: false,
        collpsed: false,
        isDiffColored: true,
        legend_type: 'solid_line',
        legend_label: ['Caltrans Districts'],
        legend_value: ['#000000ff'],
  },],}
  ];

  export const LEGEND_MAPPINGS = {
  vruDefault: getVRUDefaultCustomLegendMapping,
  default: getDefaultCustomLegendMapping,
  vru: getVRUCustomLegendMapping,
  custom: getCustomLegendMapping
};

  export const getLegendMappingByRole = (role = null, vruFlag = false) => {
  const userRole = String(role || localStorage.getItem('userRole') || '')
    .trim()
    .toLowerCase();

  if (userRole === 'default') {
    return vruFlag ? LEGEND_MAPPINGS.vruDefault : LEGEND_MAPPINGS.default;
  }

  return vruFlag ? LEGEND_MAPPINGS.vru : LEGEND_MAPPINGS.custom;
};
export const getColorForLayerId = (layerId, index = 0, label) => {
  const colors = [
    "#009BDC",
    "#FFC107",
    "#046B99",
    "#FF5722",
    "#323A45",
    "#A5AA99",
    "#e73f3f",
    "#7F3C8D",    
    "#559e83",    
    "#f97b72",   
  ];
  //Hard Code Label Colors 
  if(label === 'Fatal Injury'){
    return colors[0];
  } else if (label === 'Possible Injury') {
    return colors[1];
  } else if (label === 'Minor Injury') {
    return colors[2];
  } else if (label === 'Major Injury') {
    return colors[3];
  } else if (label === 'Property Damage Only') {
    return colors[4];
  }
  
  const customMapping = getLegendMappingByRole();
  
  // Traverse the sections
  let colorIndex = 5;
  for (const section of customMapping) {
    for (const detail of section.section_details) {
      // if (detail.type === 'layer' && detail.layer_id === layerId) {
      //   if (detail.legend_label) {
      //     const index = detail.legend_label.indexOf(label);
      //     if (index !== -1) {
      //       return detail.legend_value[index];
      //     }
      //   }
      //   // Return color in order from colors array
      //   return colors[colorIndex++ % colors.length];
      // }

      if (detail.type === 'group') {
        for (const subDetail of detail.group_details) {
          if (subDetail.layer_id === layerId) {
            if (subDetail.legend_label) {
              const index = subDetail.legend_label.indexOf(label);
              if (index !== -1) {
                return subDetail.legend_value[index];
              }
            }
            // Return color in order from colors array
            return colors[colorIndex++ % colors.length];
          }
        }
      }
    }
  }

  // Return color in order from colors array if nothing is found
  return colors[index % colors.length];

};

export const getColorByIdAndLabel = (layerId, label) => {
  const randomColors = [
    '#edab00',
    '#1b85b8',
    '#559e83',
    '#323a45',
    '#e73f3f',
    '#7F3C8D',
    '#f97b72',
    '#6f7a00ff',
    '#A5AA99',
  ];
  
  const customMapping = getLegendMappingByRole();
  
  // Traverse the sections
  for (const section of customMapping) {
    // Traverse the section details
    for (const detail of section.section_details) {
      // Check for direct layer_id match
      if (detail.type === 'layer' && detail.layer_id === layerId) {
        // Check for legend_label and find the index of the label
        if (detail.legend_label) {
          const index = detail.legend_label.indexOf(label);
          if (index !== -1) {
            return detail.legend_value[index];
          }
        }
        // Return a random color if no label match
        return randomColors[Math.floor(Math.random() * randomColors.length)];
      }

      // Traverse group details if group exists
      if (detail.type === 'group') {
        for (const subDetail of detail.group_details) {
          if (subDetail.layer_id === layerId) {
            // Find label in legend_label
            if (subDetail.legend_label) {
              const index = subDetail.legend_label.indexOf(label);
              if (index !== -1) {
                return subDetail.legend_value[index];
              }
            }
            // Return a random color if no label match
            return randomColors[Math.floor(Math.random() * randomColors.length)];
          }
        }
      }
    }
  }

  // Return a random color if nothing is found
  return randomColors[Math.floor(Math.random() * randomColors.length)];
};
